import React, { useState } from 'react';
import Layout from 'components/Layout';
import SEO from 'components/Seo';
import classes from './styles.module.scss';
import { useRouter } from 'next/router';
import { SIKKA_FAQS, PAGE_TITLE } from 'data/faq';
import { faqSchema } from 'data/Schema/faqPageSchema';
import { FaChevronLeft } from 'react-icons/fa';
import Link from 'next/link';
import useMediaQuery from 'hooks/useMediaQuery';
import FAQ from 'components/Faq';

export default function FaqPage() {
  const router = useRouter();
  const isTab = useMediaQuery('(max-width: 1000px)');

  // Map query param lang to internal lang code
  // Query params: en, hi, gu, mr, in
  // Internal codes: en, hi, gu, mr, id
  const getLangFromQuery = () => {
    const queryLang = router.query.lang;
    if (!queryLang) return 'en';
    
    // Map 'in' to 'id' for Indonesian
    if (queryLang === 'in') return 'id';
    
    // Validate language code
    const validLangs = ['en', 'hi', 'gu', 'mr', 'id'];
    return validLangs.includes(queryLang) ? queryLang : 'en';
  };

  const initialLang = getLangFromQuery();
  const [currentLang, setCurrentLang] = useState(initialLang);

  const schemaCodes = [
    {
      type: 'application/ld+json',
      code: JSON.stringify(faqSchema)
    }
  ];

  return (
    <Layout>
      <SEO
        useTitleTemplate={false}
        url={router.pathname}
        title="Frequently Asked Questions About Money making App - Sikka"
        description="Get your questions answered about how to earn money with Sikka money making app and how to get real money in the UPI wallet or bank."
        // keywords={["Best Earning App", "Online Money Earning App"]}
        schemaCodes={schemaCodes}
        // image={"/assets/images/certified-orange.png"}
      />
      <section className={classes.headerSection}>
        <h1>{PAGE_TITLE[currentLang]}</h1>
      </section>
      <section className={classes.faqContainer}>
        <FAQ 
          list={SIKKA_FAQS} 
          initialLang={initialLang}
          onLangChange={setCurrentLang}
        />
      </section>
    </Layout>
  );
}
